import type { LiveVoiceMessageCall } from "@cleo/contracts";

/** Fixed ordering also used by the World record and manifest readback. */
export function liveVoiceMessageCallValue(call: LiveVoiceMessageCall | undefined) {
  if (!call) return undefined;
  const agent = call.agent;
  return {
    requestKey: call.requestKey,
    delegationId: call.delegationId,
    callKey: call.callKey,
    agent: {
      agentKey: agent.agentKey,
      revision: agent.revision,
      mode: agent.mode,
      ...(agent.mode === "live" ? { activationRevision: agent.activationRevision } : {}),
      configDigest: agent.configDigest,
      name: agent.name,
      purpose: agent.purpose,
      style: agent.style,
      voice: agent.voice,
      backendMode: agent.backendMode,
      backendProvider: agent.backendProvider,
      backendModel: agent.backendModel,
    },
  };
}
